export default __webpack_public_path__ + "static/media/ps_05.9e90a868.png";